<ndt-account-log-level-view
   [callState]="callState$ | async"
   [account]="account"
   [form]="form"
   [title]="title"
   (formCanceled)="onCloseClick()"
   (formSubmitted)="onConfirm()"
></ndt-account-log-level-view>
